import React from "react";

import { Routes, BrowserRouter, Route } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';

import MyRoutes from "./Routes";
import ProfielContextProvider from "./context/profiel-context";
import SeisoenContextProvider from "./context/seisoen-context";
import BoerderyContextProvider from "./context/boerdery-context";
import NotificationsContextProvider from "./context/notifications-context";

import EmptyLayout from "./hoc/Layout/Empty/Empty";
import Login from "./hoc/Layout/Login/Login";

const AuthWrapper = (props) => {
  const { route } = useAuthenticator((context) => [context.route]);

  return (
    <React.Fragment>
      {
        route === "authenticated" ? (
          <ProfielContextProvider>
            <NotificationsContextProvider>
              <SeisoenContextProvider>
                <BoerderyContextProvider>
                  <MyRoutes />
                </BoerderyContextProvider>
              </SeisoenContextProvider>
            </NotificationsContextProvider>
          </ProfielContextProvider>
        ) :
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<EmptyLayout />}>
                <Route path="/" element={<Login />} />
                <Route path="*" element={<Login />} />
              </Route>
            </Routes>
          </BrowserRouter>
      }
    </React.Fragment>
  );
}

export default AuthWrapper;
